import { EventRow } from './logger.event-row';
import { loggerConstants } from './logger.constants';

export class FactoryResourcesAction extends EventRow {
    constructor(
        component: string,
        operation: string,
        resourceCount?: number
    ) {
        super(
            loggerConstants.Event_AuthoringUIAction, {
                ['operation']: operation,
                ['component']: component
            }
        );
        this.addToProperties('resourceCount', resourceCount ? resourceCount.toString() : '');
    }
}
